<svelte:options customElement={{
  tag: 'page-pagination',
  shadow: 'none',
  props: {
    current: { reflect: true, type: 'Number' },
    total: { reflect: true, type: 'Number' },
    baseUrl: { reflect: true, type: 'String', attribute: 'base-url' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * navi3：ページャー
   * パーツライブラリ準拠の mod-paginate 構造
   * @prop {number} current - 現在のページ番号
   * @prop {number} total - 総ページ数
   * @prop {string} baseUrl - ベースURL（例: '/news/page/'）
   */
  export let current = 1;
  export let total = 1;
  export let baseUrl = '#';

  $: pages = Array.from({ length: total }, (_, i) => i + 1);
  $: hasPrev = current > 1;
  $: hasNext = current < total;

  function pageUrl(page) {
    return `${baseUrl}${page}`;
  }
</script>

<div class="mod-paginate">
  {#if hasPrev}
    <a href={pageUrl(1)} class="mod-paginate-prev02" aria-label="最初へ">
      <SvgIcon name="arrow_left_double" size="md" />
    </a>
    <a href={pageUrl(current - 1)} class="mod-paginate-prev" aria-label="前へ">
      <SvgIcon name="arrow_left" size="md" />
    </a>
  {/if}

  {#each pages as page}
    {#if page === current}
      <span>{page}</span>
    {:else}
      <a href={pageUrl(page)}>{page}</a>
    {/if}
  {/each}

  {#if hasNext}
    <a href={pageUrl(current + 1)} class="mod-paginate-next" aria-label="次へ">
      <SvgIcon name="arrow_right" size="md" />
    </a>
    <a href={pageUrl(total)} class="mod-paginate-next02" aria-label="最後へ">
      <SvgIcon name="arrow_right_double" size="md" />
    </a>
  {/if}
</div>
